export default "__VITE_PUBLIC_ASSET__3190acd7__"